import React from 'react';
import PropTypes from 'prop-types';

// Components
import PriceSlider from '../../../../components/react-price-slider';

// Css
import './index.scss';

const PERCENTAGE = 100;
const DEFAULT_TIMEOUT = 1200;

class PricePerTicket extends React.Component {
  onSlidingPriceComplete = (value = {}) => {
    const {minPrice, maxPrice, updateQuery} = this.props;
    const minDollarVal = ((maxPrice - minPrice) * value.min + minPrice).toFixed(2);
    const maxDollarVal = ((maxPrice - minPrice) * value.max + minPrice).toFixed(2);

    const dollarVal = {min: minDollarVal, max: maxDollarVal};

    let minSlider = `${dollarVal.min},${this.sliderPercentageToFixed(value.min * PERCENTAGE)}`;
    let maxSlider = `${dollarVal.max},${this.sliderPercentageToFixed(value.max * PERCENTAGE)}`;

    if (value.min > value.max) {
      const temp = minSlider;
      minSlider = maxSlider;
      maxSlider = temp;
    }

    const sliderMin = value.min > 0 ? minSlider : false;
    const sliderMax = value.max < 1 ? maxSlider : false;

    updateQuery &&
      updateQuery({
        sliderMin,
        sliderMax,
      });
  };

  onChange = (value) => {
    this.timeout;

    const later = () => {
      this.timeout = null;
      this.onSlidingPriceComplete(value);
    };

    clearTimeout(this.timeout);
    this.timeout = setTimeout(later, DEFAULT_TIMEOUT);
  };

  sliderPercentageToFixed(x) {
    return Number.parseFloat(x).toFixed(2);
  }

  render() {
    const {
      averageTicketPriceCurrency,
      minPrice,
      maxPrice,
      sliderMin,
      sliderMax,
      eventPricingSummary: {maxTicketPrice} = {},
    } = this.props;

    return (
      <PriceSlider
        min={minPrice}
        max={maxPrice}
        maxTicketPrice={maxTicketPrice}
        onChange={this.onChange}
        sliders={{sliderMin, sliderMax}}
        currency={averageTicketPriceCurrency}
      />
    );
  }
}

PricePerTicket.propTypes = {
  sliderMin: PropTypes.number,
  sliderMax: PropTypes.number,

  /**
   * Min ticket price in slider
   */
  minPrice: PropTypes.number,

  /**
   * Max ticket price in slider
   */
  maxPrice: PropTypes.number,
  updateQuery: PropTypes.func,

  /**
   * Currency code of averageTicketPrice property
   */
  averageTicketPriceCurrency: PropTypes.string,

  /**
   * Event summary
   */
  eventPricingSummary: PropTypes.object,
};

export default PricePerTicket;
